import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { HttpRequestsService } from 'src/app/services/http-requests.service';

interface Priorities {
  Circularity: string;
  Climate: string;
  Innovation: string;
  Nutrition: string;
}

@Component({
  selector: 'app-city-evaluation-food2030-impacts',
  templateUrl: './city-evaluation-food2030-impacts.component.html',
  styleUrls: ['./city-evaluation-food2030-impacts.component.scss']
})
export class CityEvaluationFood2030ImpactsComponent implements OnInit {
  
  public city = history.state.city;
  public country = history.state.country;
  public priorities: any = [];

  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  
  constructor(private req: HttpRequestsService<any>) { }

  ngOnInit(): void {
    this.req.getCityPriorities(this.city).subscribe((res: Priorities[])=>{
      this.priorities = res[0]
    })
  }

}
